import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb, BreadcrumbItem, Col, Row } from "reactstrap";

const CustomBreadcrumb = (props) => {
  const { items, updateDatasource } = props;

  const onClick = (e) => {
    updateDatasource({ parentId: e.target.id });
  };

  return (
    <Row>
      <Col xs="12">
        <Breadcrumb tag="nav" listTag="div">
          <BreadcrumbItem tag="a" onClick={onClick}>Raiz</BreadcrumbItem>
          {
            items.map((item, index) => {
              return (
                <BreadcrumbItem tag="a" key={`BD_${index}`} id={item.id} onClick={onClick}>
                  { item.name}
                </BreadcrumbItem>
              );
            })
          }
        </Breadcrumb>
      </Col>
    </Row>
  );
};

CustomBreadcrumb.propTypes = {
  updateDatasource: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  })).isRequired
};

export default CustomBreadcrumb;